import { calculateEffectiveGrade, GradingMethod } from '../../domain';
import { ExamSuspendDataStore } from './exam-suspend-data-state-store'

export function calculateEffecticeGrade(examStore: ExamSuspendDataStore) {
  return async function(id: string, gradingMethod: GradingMethod) {
    const state = await examStore.query([ id ])
    const allAttempts = state[0].attempts
    const effectiveGrade = calculateEffectiveGrade(allAttempts, gradingMethod)
    if (effectiveGrade === false) {
      return false
    }

    return effectiveGrade

  }
}
